/* eslint-disable camelcase */
import React, { ReactNode, useContext, useEffect, useState } from 'react';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';

import ContactSearchContext from '@totem/components/contactSearch/contactSearchContext';
import {
  ContactSearchInput,
  ContactSearchRequest,
  ContactSearchResultEntry,
} from '@totem/components/contactSearch/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull } from '@totem/utilities/common';
import { CONTACT_SEARCH_ENDPOINT } from '@totem/utilities/endpoints';
type Props = {
  refresh?: boolean;
  onRecordTotalChanged?: (total: number) => void;
  onDataRefreshRequested?: () => void;
  children?: ReactNode;
  endPointUrl?: string;
  defaultSearchTerm?: string;
};
const ContactSearchContainer = ({
  children,
  onRecordTotalChanged,
  refresh,
  onDataRefreshRequested,
  endPointUrl,
  defaultSearchTerm,
}: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [data, setData] = useState<ContactSearchResultEntry[]>(null);
  const [selectedContact, setSelectedContact] =
    useState<ContactSearchResultEntry>(null);
  const [selectedAction, setSelectedAction] = useState<string>('');
  const [input, updateInput] = useQueryParams({
    search_term: withDefault(
      StringParam,
      isNotNull(defaultSearchTerm) && defaultSearchTerm !== ''
        ? defaultSearchTerm
        : '',
    ),
  });
  const setInput = (updated: Partial<ContactSearchInput>) => {
    updateInput({ ...input, ...updated });

    setRefreshData(true);
  };
  useEffect(() => {
    if (
      typeof onRecordTotalChanged !== 'undefined' &&
      onRecordTotalChanged !== null
    ) {
      onRecordTotalChanged(totalRecords);
    }
  }, [onRecordTotalChanged, totalRecords]);

  useEffect(() => {
    if (
      refresh &&
      typeof onDataRefreshRequested !== 'undefined' &&
      onDataRefreshRequested !== null
    ) {
      setRefreshData(true);

      onDataRefreshRequested();
    }
  }, [refresh, onDataRefreshRequested]);

  useEffect(() => {
    setRefreshData(true);
  }, [endPointUrl]);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);
      const params: ContactSearchRequest = {
        search_term: input.search_term,
      };
      const url =
        typeof endPointUrl !== 'undefined' && endPointUrl !== null
          ? endPointUrl
          : CONTACT_SEARCH_ENDPOINT;
      fetch(`${url}`, {
        method: 'POST',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
        body: JSON.stringify(params),
      })
        .then((res) => res.json())
        .then((result: ContactSearchResultEntry[]) => {
          setData(result);

          setTotalRecords(result.length);
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [refreshData, refresh, getApiToken]);
  const handleAction = (
    newAction: string,
    contact: ContactSearchResultEntry,
  ) => {
    setSelectedAction(newAction);

    setSelectedContact(contact);
  };
  return (
    <ContactSearchContext.Provider
      value={{
        input,
        setInput,
        loading: isLoading,
        data,
        selectedAction,
        selectedContact,
        totalRecords,
        onAction: handleAction,
      }}
    >
      <div>{children}</div>
    </ContactSearchContext.Provider>
  );
};
export default ContactSearchContainer;
